<template>
  <div class="container">
    <van-nav-bar :title="$t('mine.withdraw')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()"/>
      </template>
      <template #right v-if="false">
        <span class="nav-right" @click="$router.push({path:'/WithdrawRecord'})">{{ $t("withdraw.record") }}</span>
      </template>
    </van-nav-bar>

    <!-- 提现金额 -->
  <div class="card withdraw-input-section"  style="margin-top: 10px;background-color: #f2f5fe;">
    <h2>{{ $t("要退出的点数") }}</h2>
    <div class="input-wrapper">
      <input  class="amount"  v-model="withdraw_money" type="number" :placeholder="$t('转换点数')" >
      <div class="unit">{{ $t("点") }}</div>
    </div>
    <div class="min-hint">{{ $t("最小值") }} {{ formatNumber(withdrawRole.min) }} {{ $t("点") }}</div>
  </div>

  <!-- 银行卡信息 -->
  <div class="card">
    <div class="bank-info-title">{{ $t("收到的银行账户信息") }}</div>
    <div class="bank-info-desc">{{ $t("请输入正确的帐户信息以获取积分。") }}</div>

    <div class="form-group" @click="showBank = !showBank">
      <div class="form-icon">
        <img src="/img/recharge/bank.jpg" class="icon">
      </div>
      <div class="van-field__body" style="color: #323233" v-if="bankid" v-html="branch"></div>
      <div class="van-field__body" v-else style="color: #c8c9cc">
        {{ $t("请选择银行兑换") }}
      </div>

      <img src="/img/recharge/down.png" class="icon"/>
    </div>
    <van-popup v-model="showBank" round position="bottom" :style="{ height: '320px' }" >
      <van-picker
          show-toolbar
          :columns="banks"
          @confirm="onConfirm"
          @cancel="onCancel">
        <template #confirm>
          <span>{{ $t("确定") }}</span>
        </template>
        <template #cancel>
          <span>{{ $t("取消") }}</span>
        </template>
      </van-picker>
    </van-popup>

    <div class="notice-box">
      <div>
        <div class="notice-title"><img src="/img/recharge/halved.jpg" class="icon">{{ $t("注意") }}</div>
        <div class="notice-text">
          {{ $t("积分将转移到您的银行账户。") }}<br>
          {{ $t("处理时间为5-30分钟，具体取决于银行。") }}
        </div>
      </div>
    </div>
  </div>

  <!-- 安全验证 -->
  <div class="card">
    <div class="security-title">{{ $t("安全身份验证") }}</div>
    <div class="security-desc">{{ $t("输入2级密码以确认交易") }}</div>

    <div class="password-wrapper">
      <img src="/img/login/lock.jpg" class="icon">
      <input  :type="passwordType" id="password" v-model="password" :placeholder="$t('输入二级密码')" >
      <img src="/img/login/eye-off.jpg" v-if="passwordType === 'password'" class="fa-regular fa-eye-slash password-toggle icon" @click="switchPasswordType">
      <img src="/img/login/eye.jpg" v-else class="fa-regular fa-eye-slash password-toggle icon" @click="switchPasswordType">
    </div>
    <div class="forgot-link" @click="service" v-if="false">
      <span>{{ $t("忘记二级密码？") }}</span>
    </div>
  </div>

  <!-- 提现费用与到账金额 -->
  <div class="card">
    <div class="fee-row">
      <span class="fee-label">{{ $t("提款费") }}</span>
      <span class="fee-value">{{ $t("免费") }}</span>
    </div>
    <div class="receive-row">
      <span class="receive-label">{{ $t("收到的分数") }}</span>
      <span class="receive-value">{{ formatNumber(withdraw_money) }} {{ $t("点") }}</span>
    </div>
    <div class="receive-row">
      <span class="receive-label">{{ $t("账户余额") }}</span>
      <span class="receive-value">{{ formatNumber(userInfo.money * 1) }} {{ $t("点") }}</span>
    </div>
  </div>


    <button type="button"  class="login-btn" @click="doWithdraw">{{$t("确认")}}</button>
</div>
</template>

<script>
export default {
  data() {
    return {
      branch: "",
      bankid: "",
      showBank:false,
      showPopover: false,
      withdraw_money: "",
      userInfo: {},
      withdrawRole: {},
      passwordType: "password",
      password: "",
      banks:[]
    };
  },
  methods: {

    //客服
    service() {
      window.location.href = this.$store.getters.getBaseInfo.kefu;
    },
    onConfirm(value) {
      this.branch = value.text
      this.bankid = value.value
      this.showBank = false;
    },
    onCancel() {
      this.showBank = false;
    },
    switchPasswordType() {
      this.passwordType = this.passwordType === 'password' ? 'text' : 'password'
    },
    back() {
      return window.history.back();
    },
    getUserInfo() {
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res => {
        if (res.code === 200) {
          this.userInfo = res.data;
          this.name = res.data.name;
        } else if (res.code === 401) {
          this.$toast(this.$t(res.msg));
        }
      })
    },

    getUserBankInfo() {
      this.$http({
        method: 'get',
        url: 'user_get_bank'
      }).then(res => {
        if (res.code === 200) {
          if (res.data.is_bank) {
            this.is_bind = true;
            this.bankInfo = res.data.info;
            for(var i = 0; i < this.bankInfo.length; i++){
              this.banks.push({
                "value": this.bankInfo[i].id,
                "text": this.bankInfo[i].branch+"<span style='margin-left: 10PX'>"+this.bankInfo[i].branch_number+"</span>",
              });
            }
          } else {
            this.is_bind = false;
          }
        } else if (res.code === 401) {
          this.$toast(this.$t(res.msg));
        }
      })
    },
    getUserWithdrawRole() {
      this.$http({
        method: 'get',
        url: 'user_get_withdraw_role'
      }).then(res => {
        if (res.code === 200) {
          this.withdrawRole = res.data;
        } else if (res.code === 401) {
          this.$toast(this.$t(res.msg));
        }
      })
    },
    allMoeny() {
      this.withdraw_money = this.userInfo.money * 1;
    },
    doWithdraw() {
      if(this.bankid == ""){
        this.$toast(this.$t("请选择银行兑换"));
        return false;
      }
      if (this.withdraw_money <= 0) {
        this.$toast(this.$t("转换点数"));
        return false;
      } else {

        if (this.password.length <= 0) {
          this.$toast(this.$t("输入二级密码"));
          return false;
        }
        this.$http({
          method: 'get',
          data: {money: this.withdraw_money, password: this.password, bankid:this.bankid},
          url: 'user_set_withdraw'
        }).then(res => {
          if (res.code === 200) {
            location.reload()
            this.getUserInfo();
            this.getUserWithdrawRole();
          } else if (res.code === 401) {
            this.$toast(this.$t(res.msg));
          } else if (res.code === 402) {
            this.$toast(this.$t(res.msg));
            return false;
          }else if (res.code === 404) {
            this.$toast(this.$t(res.msg)+" "+(this.withdrawRole.withraw_time_start +" - "+ this.withdrawRole.withraw_time_end));
            return false;
          }
          let num = "";
          if (res.msg == "提现金额不能少于：") {
            num = this.withdrawRole.min;
          } else if (res.msg == "提现金额不能大于：") {
            num = this.withdrawRole.max;
          }

          this.$toast(this.$t("msg." + res.msg) + num);
        })
      }
    },
    withdrawInfo() {
      this.showPopover = true;
    }
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({path: '/Login'})
    } else {
      this.getUserInfo();
      this.getUserBankInfo();
      this.getUserWithdrawRole();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
::v-deep .van-picker__toolbar{
  height: 100px;
}
::v-deep .van-picker__cancel {
  padding: 20px 20PX;
  font-size: 32px;
}
::v-deep .van-picker__confirm {
  padding: 20px 20PX;
  font-size: 32px;
}
::v-deep .van-ellipsis{
  font-size: 32px;
}
.van-field__body{
  width: 100%;
}
.icon{
  width: 18PX;
}
.back-btn {
  font-size: 20PX;
  color: #333;
  text-decoration: none;
}

.header h1 {
  font-size: 18PX;
  font-weight: 600;
}

.header-right {
  width: 20PX; /* 占位保持标题居中 */
}


/* 通用卡片样式 */
.card {
  background-color: #fff;
  border-radius: 12PX;
  padding: 16PX;
  box-shadow: 0 2PX 8PX rgba(0,0,0,0.02);
  margin: 0 16PX 12PX;
  border: 1px solid #f4f4f4;
}

/* 提现金额区域 */
.withdraw-input-section h2 {
  font-size: 16PX;
  font-weight: 500;
  margin-bottom: 10PX;
  color: #333;
}

.input-wrapper {
  display: flex;
  align-items: baseline;
  border-bottom: 2PX dotted #4a90e2;
  padding-bottom: 10PX;
  margin-bottom: 8PX;
}

.input-wrapper .amount {
  font-size: 28PX;
  font-weight: bold;
  color: #1a73e8;
  border: none;
  background: transparent;
  outline: none;
  flex: 1;
  width: 100%;
}

.input-wrapper .unit {
  font-size: 16PX;
  color: #333;
  font-weight: 500;
}

.min-hint {
  font-size: 13PX;
  color: #666;
}

/* 银行卡信息区域 */
.bank-info-title {
  font-size: 16PX;
  font-weight: 600;
  margin-bottom: 8PX;
}

.bank-info-desc {
  font-size: 13PX;
  color: #666;
  margin-bottom: 15PX;
}

.form-group {
  display: flex;
  align-items: center;
  background-color: #f8f9fa;
  border-radius: 8PX;
  padding: 12PX 15PX;
  margin-bottom: 12PX;
  border: 1PX solid transparent;
  transition: all 0.3s;
}

.form-group:focus-within {
  border-color: #e60012;
  background-color: #fff;
}

.form-icon {
  width: 32PX;
  height: 32PX;
  background-color: #e7f1ff;
  color: #007bff;
  border-radius: 8PX;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12PX;
  font-size: 16PX;
}

.form-group input, .form-group select {
  flex: 1;
  border: none;
  background: transparent;
  font-size: 15PX;
  outline: none;
  color: #333;
}

.form-group select {
  appearance: none;
  color: #999;
  cursor: pointer;
}

.arrow-down {
  color: #999;
  font-size: 12PX;
}

/* 注意事项 */
.notice-box {
  display: flex;
  background-color: #f0f7ff;
  padding: 12PX;
  border-radius: 8PX;
  margin-top: 15PX;
  gap: 10PX;
}

.notice-icon {
  color: #007bff;
  font-size: 18PX;
  margin-top: 2PX;
}

.notice-title {
  font-size: 13PX;
  font-weight: 600;
  margin-bottom: 4PX;
  display: flex;
  align-items: center;
  color: #1a73e8;
}

.notice-text {
  font-size: 13PX;
  color: #555;
  line-height: 1.5;
}

/* 安全验证区域 */
.security-title {
  font-size: 16PX;
  font-weight: 600;
  margin-bottom: 8PX;
}

.security-desc {
  font-size: 13PX;
  color: #666;
  margin-bottom: 15PX;
}


.password-wrapper input:focus {
  border-color: #e60012;
}

.password-wrapper {
  display: flex;
  align-items: center;
  border: 1PX solid #ddd;
  border-radius: 8PX;
  padding: 0 12PX;
  background-color: #fff;
  height: 48PX;
}

.password-wrapper i {
  color: #999;
  font-size: 16PX;
  margin-right: 10PX;
}

.password-wrapper input {
  flex: 1;
  border: none;
  outline: none;
  font-size: 14PX;
  color: #333;
  margin-left: 5PX;
}

.lock-icon {
  position: absolute;
  left: 12PX;
  color: #999;
}

.toggle-password {
  position: absolute;
  right: 12PX;
  color: #999;
  cursor: pointer;
}

.forgot-link {
  text-align: right;
  margin-top: 10PX;
  font-size: 13PX;
  color: #007bff;
}

.forgot-link a {
  text-decoration: none;
  color: inherit;
}

/* 费用与结算 */
.fee-row, .receive-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15PX 0;
}

.fee-label {
  font-size: 15PX;
  color: #333;
}

.fee-value {
  font-size: 15PX;
  color: #28a745;
  font-weight: 500;
}

.receive-row {
  border-top: 1PX dashed #ddd;
  margin-top: 5PX;
  padding-bottom: 0;
}

.receive-label {
  font-size: 15PX;
  font-weight: 500;
}

.receive-value {
  font-size: 16PX;
  font-weight: bold;
  color: #333;
}

/* 底部按钮 */
.bottom-action {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: #fff;
  padding: 15PX 20PX;
  box-shadow: 0 -2PX 10PX rgba(0,0,0,0.05);
  z-index: 10;
}

.submit-btn {
  width: 100%;
  background-color: #c00000;
  color: #fff;
  border: none;
  padding: 14PX;
  border-radius: 8PX;
  font-size: 16PX;
  font-weight: 600;
  cursor: pointer;
}

.submit-btn:active {
  background-color: #a00000;
}

/* 悬浮按钮 */
.fab {
  position: fixed;
  bottom: 80PX;
  right: 20PX;
  width: 45PX;
  height: 45PX;
  background-color: #c00000;
  color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4PX 10PX rgba(0,0,0,0.2);
  z-index: 11;
  cursor: pointer;
}

/* 底部中央悬浮图标 */
.bottom-center-fab {
  position: fixed;
  bottom: 60PX;
  left: 50%;
  transform: translate(-50%, 0);
  width: 50PX;
  height: 50PX;
  background-color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4PX 10PX rgba(0,0,0,0.1);
  z-index: 11;
  border: 1PX solid #eee;
}
/* 登录按钮 */
.login-btn {
  background-color: #d8000f;
  color: white;
  border: none;
  padding: 14PX;
  border-radius: 8PX;
  font-size: 16PX;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.2s;
  margin: 0 16PX 25PX 16PX;
}

.login-btn:hover {
  background-color: #c0000d;
}
</style>
